import { render, staticRenderFns } from "./_cate_id.vue?vue&type=template&id=a8f86c32&scoped=true"
import script from "./_cate_id.vue?vue&type=script&lang=js"
export * from "./_cate_id.vue?vue&type=script&lang=js"
import style0 from "./_cate_id.vue?vue&type=style&index=0&id=a8f86c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f86c32",
  null
  
)

export default component.exports